import {
  Body,
  Flex,
  LazyImage,
  Loading,
  Modal,
  ModalBody,
  Shape,
  Title,
  styled,
} from '@teko/ds-desktop';
import { LeftOutlined } from '@teko/ds-icon';
import { ProductCarousel, REGION_NAME } from '@teko/teko-ecommerce';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { isServerless } from 'helpers';
import { useSearch } from 'hooks';
import { t } from 'i18n';
import { IRelatedProductParams } from 'types';

interface RelatedProductsModalProps {
  productInfo: IRelatedProductParams;
  onBack?: () => void;
  onCloseModal?: () => void;
}

export const RelatedProductsModal: React.FC<RelatedProductsModalProps> = ({
  productInfo,
  onBack,
  onCloseModal,
}) => {
  const { sku, imageUrl, name } = productInfo;

  const searchRelatedProductsParams = !!sku
    ? {
        page: 1,
        pageSize: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
        filter: {
          skuToReturnSimilarProducts: sku,
        },
      }
    : {};

  const { result: searchRelatedProductsResult, isLoading } = useSearch(
    searchRelatedProductsParams,
  );

  return (
    <Modal
      visible={!!sku}
      title={
        <Flex align="center" gap="s8" paddingLeft="s16" paddingTop="s20">
          <LeftOutlined size={20} color="black" onClick={onBack} />
          <Title level={3}>{t('Sản phẩm tương tự')}</Title>
        </Flex>
      }
      onClose={onCloseModal}
      footer={null}
      width={'70%'}
      zIndex={1051}
      contentStyle={{ padding: 0 }}
    >
      <ModalBody padding={['s0', 's0']}>
        <Loading isLoading={isLoading}>
          <StyledShape>
            <Flex
              backgroundColor="white"
              padding="s8"
              borderRadius="m"
              align="center"
              gap="s8"
              width="360px"
            >
              {!!imageUrl && (
                <LazyImage width="60px" height="60px" contain src={imageUrl} />
              )}
              <div style={{ flex: 1 }}>
                <Body level={1} line={2}>
                  {name}
                </Body>
              </div>
            </Flex>
            {typeof searchRelatedProductsResult.pagination.totalItems ===
            'number' ? (
              <Body level={1} marginTop="s16" marginBottom="s16">
                {t('Tìm thấy')}{' '}
                <strong>
                  <strong>
                    {searchRelatedProductsResult.pagination.totalItems <
                    LIMIT_ITEM_PER_PAGE_PRODUCT_LIST
                      ? searchRelatedProductsResult.pagination.totalItems
                      : LIMIT_ITEM_PER_PAGE_PRODUCT_LIST}{' '}
                  </strong>
                </strong>
                {t('Sản phẩm tương tự')}
              </Body>
            ) : null}
            {!!searchRelatedProductsResult.products.length ? (
              <ProductCarousel
                products={searchRelatedProductsResult.products}
                productsPerRow={5}
                regionName={REGION_NAME.SIMILAR_PRODUCTS_POPUP}
                virtual={isServerless()}
              />
            ) : null}
          </StyledShape>
        </Loading>
      </ModalBody>
    </Modal>
  );
};

const StyledShape = styled(Shape)`
  background: #f5f5f5;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 8px 16px;
`;
